<template>
    <div id="email-container">
        <div class="v-toolbar__content v-toolbar__title" style="color:#303e67 !important">Notifications</div>
        <div class="card-body">
            <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
                <template v-for="(program, index) in programs">
                    <li class="nav-item" @click="getDataNotificationSettingForForm(program)">
                        <a v-bind:class="{ active: index == 0 }" class="nav-link profile-tabs" id="general_detail_tab"
                            data-toggle="pill" v-bind:href="'#detail_' + program.id">{{ program.name }}</a>
                    </li>
                </template>
            </ul>
        </div>


        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="1080px" :retain-focus="false">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Add Notification</span>
                        <v-spacer></v-spacer>
                        <v-switch v-model="formMail.active" inset color="success" label="Active"></v-switch>

                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field label="Program" v-model="formMail.program.name" outlined
                                        disabled></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field label="Category" v-model="formMail.event.name" outlined
                                        disabled></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field label="Subject" v-model="formMail.subject"
                                        :error-messages="formMail.errors.subject" required outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mb-2" id="content">
                                    <v-textarea variant="outlined" auto-grow label="Content" v-model="formMail.content"
                                        :init="init"
                                        style="width:100%;border: 1px solid #999;padding: 10px;border-radius: 5px;"></v-textarea>
                                    <div class="v-messages theme--light error--text" v-if="formMail.errors.content">
                                        {{ formMail.errors.content[0] }}</div>
                                </v-col>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$customerName')"
                                    variant="outline-primary">Customer Name</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$customerEmail')"
                                    variant="outline-primary">Customer Email</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$cardNumber')"
                                    variant="outline-primary">Card Number</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$customerNumber')"
                                    variant="outline-primary">Customer Number</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$program')"
                                    variant="outline-primary">Program</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$storeName')"
                                    variant="outline-primary">Store Name</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$orderNumber')"
                                    variant="outline-primary">Order Number</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$signUpPoints')"
                                    variant="outline-primary">Sign-Up Points</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$firtPurchaseBonus')"
                                    variant="outline-primary">Firt Purchase Bonus</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$pointsRedeemed')"
                                    variant="outline-primary">Points Redeemed</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$pointsTopUp')"
                                    variant="outline-primary">Points TopUp</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$activePoints')"
                                    variant="outline-primary">Active Points</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$expiredPoints')"
                                    variant="outline-primary">Expired Points</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$expireDate')" variant="outline-primary">Points Expire Date</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$balance')"
                                    variant="outline-primary">Balance</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$rewardBalance')"
                                    variant="outline-primary">Reward Balance</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$pointsValidDays')"
                                    variant="outline-primary">Points Valid Days</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$lockedPoints')"
                                    variant="outline-primary">Locked Points</v-chip>

                                <v-chip class="mr-1 mb-1" outlined @click="addTag('$code')"
                                    variant="outline-primary">Code</v-chip>

                            </v-row>
                            <!--                            <v-row class="d-flex align-center">
                                                            <v-text-field class="mt-2" label="Send Test Notification" v-model="formMail.notification" outlined :error-messages="formMail.errors.notification"></v-text-field>
                                                            <v-btn icon @click="sendNotification"><v-icon>mdi-send</v-icon></v-btn>
                                                        </v-row>-->
                        </v-container>
                    </v-card-text>
                    <v-card-actions style="position: absolute; top:94%; left: 84%;" class="pa-2">
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                        <v-btn color="blue darken-1" text @click="saveNotification()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>


        <div class="tab-content detail-list" id="pills-tabContent">
            <template v-for="(program, index) in programs">
                <div class="tab-pane fade active" v-bind:class="{ show: index == 0 }" v-bind:id="'detail_' + program.id">

                    <v-layout row wrap>
                        <v-flex xs12 class="pd-right-25" style="margin: 0 25px;">

                            <v-toolbar flat color="transparent">
                                <v-toolbar-title></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <!--                    <div class="mx-3 fl">-->
                                <!--                        <b-button @click="uuid = null; dataForm = true" variant="outline-primary">Add Email</b-button>-->
                                <!--                    </div>-->
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line clearable
                                    hide-details
                                    :style="{ 'max-width': ($vuetify.breakpoint.xs) ? '135px' : '320px' }"></v-text-field>
                            </v-toolbar>
                            <v-data-table :mobile-breakpoint="0" class="mb-5" :headers="headers" :items="rows"
                                :loading="loading" loading-text="Loading... Please wait" :search="search" item-key="uuid"
                                :options.sync="options" :show-select="settings.select_all"
                                header-props.sort-icon="arrow_drop_down" :items-per-page="options.itemsPerPage"
                                @page-count="pageCount = $event" hide-default-footer :page.sync="options.page">

                                <template :slot="'item.' + item.value" slot-scope="props" v-for="(item, index) in headers">
                                    <div v-if="index != Object.keys(headers).length - 1 || !settings.actions"
                                        :style="item.style">
                                        <div v-if="item.type === 'boolean'" class="text-xs-center">
                                            <div v-if="props.item[item.value] === 1 || props.item[item.value] === '1'">
                                                <v-icon small>check</v-icon>
                                            </div>
                                            <div v-else>
                                                <v-icon small>close</v-icon>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'link'">
                                            <a :href="props.item[item.value]" target="_blank">{{
                                                props.item[item.value].replace('http://', '').replace('https://',
                                                    '').replace('//', '')
                                            }}</a>
                                        </div>
                                        <div v-else-if="item.type === 'campaign_link'">
                                            <a :href="props.item[item.value] + '/staff'" target="_blank"
                                                style="font-weight: bold">Staff
                                                Area</a> | <a :href="props.item[item.value]" target="_blank">{{
                                                    props.item[item.value].replace('http://', '').replace('https://',
                                                        '').replace('//', '')
                                                }}</a>
                                        </div>
                                        <div v-else-if="item.type === 'number' || item.type === 'currency'">
                                            <div class="text-xs-right">{{ props.item[item.value] }}</div>
                                        </div>
                                        <div v-else-if="item.type === 'date_time'">
                                            <span
                                                v-html="parseDateTime(props.item[item.value], item.format, item.color_is_past, item.color_is_future)"></span>
                                        </div>
                                        <div v-else-if="item.type === 'image'">
                                            <v-img :src="props.item[item.value]" class="elevation-1 my-3 d-block"
                                                v-if="props.item[item.value]" contain :max-width="item.max_width"
                                                :max-height="item.max_height"></v-img>
                                        </div>
                                        <div v-else-if="item.value === 'avatar'" class="text-xs-center">
                                            <v-avatar :tile="false" size="32" color="grey lighten-4">
                                                <v-img :src="props.item[item.value]" v-if="props.item[item.value]"></v-img>
                                            </v-avatar>
                                        </div>
                                        <div v-else @click="goToProfile(item, props.item.uuid)">
                                            <span v-if="item.value === 'name'" style="cursor: pointer;">{{
                                                props.item[item.value] }}</span>
                                            <span v-else>{{ props.item[item.value] }}</span>
                                        </div>
                                    </div>
                                    <div v-if="index == Object.keys(headers).length - 1 && settings.actions">

                                        <div class="action-menu-wrapper  d-flex">
                                            <span v-for="(item, index) in actions">
                                                <v-tooltip top v-if="item.action">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn class="mr-1 mt-0 mb-0" v-on="on" :dark="item.dark"
                                                            :color="item.color" icon small
                                                            @click="getNotification(props.item.id, props.item)">
                                                            <v-icon small>{{ item.icon }}</v-icon></v-btn>
                                                    </template>
                                                    <span>{{ item.text }}</span>
                                                </v-tooltip>
                                                <v-divider v-else vertical class="grey lighten-2"
                                                    style="vertical-align: middle;"></v-divider>
                                            </span>
                                        </div>

                                    </div>
                                </template>

                                <template v-slot:footer>
                                    <v-row>
                                        <v-col :cols="8">
                                            <div v-if="[1, 2, 4].includes(role)" class="ma-3">
                                                <v-btn v-if="settings.select_all" depressed small color="error"
                                                    :disabled="disableDeleteSelected" @click="deleteSelected">{{
                                                        $t('delete_selected') }}
                                                </v-btn>
                                            </div>
                                        </v-col>
                                        <v-col :cols="2">
                                            <v-select :items="itemsPerPageOptions" v-model="options.itemsPerPage"
                                                label="Rows per page"></v-select>
                                        </v-col>
                                        <v-col :cols="2">
                                            <v-pagination v-model="options.page" :length="pageCount"
                                                :total-visible="7"></v-pagination>
                                        </v-col>
                                    </v-row>
                                </template>

                                <template v-slot:no-data>
                                    <div v-if="!loading" class="text-xs-center">
                                        Your search and/or filter found no results.
                                    </div>
                                    <div v-if="loading" class="text-xs-center">
                                        Loading data
                                    </div>
                                </template>

                            </v-data-table>
                        </v-flex>
                    </v-layout>

                </div>
            </template>
        </div>

    </div>
</template>


<script>
// TinyMCE
import 'tinymce/tinymce'
import 'tinymce/icons/default/icons'
import 'tinymce/themes/silver/theme'
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css'
import contentUiCss from 'tinymce/skins/ui/oxide/content.css';

// TinyMCE plugins
// https://www.tiny.cloud/docs/tinymce/6/plugins/
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/help/plugin'
import 'tinymce/plugins/wordcount/plugin'

import Editor from '@tinymce/tinymce-vue'


export default {
    components: {
        'editor': Editor
    },
    $_veeValidate: {
        validator: 'new'
    },
    data(){

        let actions_form = [];
        if ([1, 2, 4].includes(this.$auth.user().role)) {
            actions_form.push(
                {
                    action: "edit",
                    color: "secondary",
                    dark: false,
                    icon: "edit",
                    text: "Edit",
                }
            );
        }
        return {
            init: {
                skin: false,
                plugins: 'lists link image table code help wordcount',
                content_css: false,
                content_style: contentUiCss.toString(),
            },
            role: this.$auth.user().role,
            dataToForm: {},
            dialog: false,
            loading: true,
            disableDeleteSelected: true,
            search: '',
            openMenu: [],
            settings: {
                actions: true,
                actions_width: "90px",
                create: true,
                select_all: false,
            },
            dataForm: false,
            actions: actions_form,
            translations: [],
            rows: [],
            filters: {},
            options: {
                sortBy: ['event'],
                sortDesc: [false],
                page: 1,
                itemsPerPage: 10,
                filters: []
            },
            pageCount: 0,
            itemsPerPageOptions: [10, 25, 50, 75, 100],
            headers: [
                {
                    text: 'Event',
                    align: 'left',
                    value: 'event',
                },
                {
                    text: 'Active',
                    align: 'center',
                    value: 'active',
                    type: 'boolean',
                },
                {
                    text: 'Subject',
                    align: 'center',
                    value: 'subject',
                    sortable: false,
                },
                {
                    text: 'Sent',
                    align: 'center',
                    value: 'sent',
                },
                {
                    text: 'Actions',
                    align: 'center',
                    sortable: false,
                    value: 'actions',
                },
            ],
            maxCount: 140,
            remainingCount: 140,
            formModel: {},
            loadingForm: true,
            programs: [],
            programID: Number,
            form: [],
            formMail: {
                program: { name: null },
                event: { name: null },
                subject: null,
                active: true,
                content: "<h1 style=\"text-align: center;\"><span style=\"background-color: rgb(126, 140, 141);\"><strong>Header</strong></span></h1>\n" +
                    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ornare sodales facilisis. Duis egestas sagittis massa, non laoreet libero mollis eget. Nullam in vulputate risus, quis accumsan nisi. Pellentesque posuere arcu vitae augue molestie lobortis. Aliquam erat volutpat. Cras volutpat luctus mi ac bibendum. Duis consectetur metus et gravida consequat. Praesent risus augue, sollicitudin non euismod quis, tristique non libero. Nam sit amet odio a urna tempus dictum sed nec ex. Nam sed eros eu mi pharetra venenatis. Proin vel eleifend orci.</p>\n" +
                    "<p>Curabitur semper, massa vehicula efficitur aliquam, massa ex congue turpis, quis pulvinar leo diam nec est. Aliquam sodales massa magna, et ultricies lectus posuere ut. Sed dictum tellus diam, vel sollicitudin leo accumsan a. In mattis in lorem eu feugiat. Suspendisse sed ante mauris. Pellentesque quis lectus ut tellus ultrices euismod. Nulla volutpat quam diam, quis porta leo ullamcorper sed. Sed ullamcorper diam vel urna commodo vestibulum.</p>\n" +
                    "<p><span style=\"background-color: rgb(206, 212, 217);\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></p>",
                notification: null,
                errors: {}
            },
            tabCount: 1,
            ClassicEditor: window.ClassicEditor,
            selectedTab: 'tab1',
            selectedSubTab: {
                tab1: 'sub1',
                tab2: 'sub1',
                tab3: 'sub1',
                tab4: 'sub1',
                tab5: 'sub1',
                tab6: 'sub1',
                tab7: 'sub1',
                tab8: 'sub1',
                tab9: 'sub1',
                tab10: 'sub1',
                tab11: 'sub1',
                tab12: 'sub1'
            },
            cacheParam: '{id}'
        }
    },
    watch: {
        form: function () {
            /*if (this.uuid) {
              const items = _.filter(_.concat(_.get(this.form.items, 'tab1.subs.sub1.items'), _.get(this.form.items, 'tab1.subs.sub2.items')), 'refresh');
              _.forEach(items, item => {
                this.check(item);
              });
            }*/
        }
    },
    props: {
        api: {
            default: '/app/data-form',
            required: false,
            type: String
        },
        programApi:
        {
            default: '/app/getprograms',
            required: false,
            type: String
        },
        notificationUidFromApi: {
            default: '/app/getnotificationsetting',
            required: false,
            type: String
        },
        model: {
            default: 'App\\NotificationSetting',
            required: false,
            type: String
        },
        customer_id: {
            default: null,
            required: false,
            type: Number
        },
        program: {
            default: null,
            required: false,
            type: Number
        },
        item: {
            default: null,
            required: false,
            type: Object
        }
    },
    computed: {
        app() {
            return this.$store.getters.app
        },
    },
    created() {
        this.$validator.extend('nullable', {
            validate: (value, [testProp]) => { return true; }
        });
        this.$validator.extend('unique', {
            validate: (value, [testProp]) => { return true; }
        });
        this.$validator.extend('not_in', {
            validate: (value, [testProp]) => { return true; }
        });

        moment.locale(this.$auth.user().locale);
    },
    beforeMount() {
        this.getProgramsByUser();

        // this.getUIDFromProgram();
    },
    methods: {
        /*sendNotification(){
            let formMail = this.formMail
            formMail.erros = {}
            axios.post('/notifications/send', formMail).then(response => {
                this.$root.$snackbar('E-mail sent')
                this.dialog = false
                formMail.notification = null
            })
                .catch(function(err){
                    if(err.response.status === 422) {
                        formMail.errors = err.response.data.errors
                    }
                });
        },*/
        getNotification(id, item) {
            axios.get(`/notifications/${id}`, {
                params: {
                    programId: this.programID,
                    eventId: item.event_id,
                }
            }).then(response => {
                this.dialog = true;
                this.formMail.id = response.data.id;
                this.formMail.program = response.data.program;
                this.formMail.event = response.data.event;
                this.formMail.subject = response.data.subject;
                this.formMail.active = response.data.active ? 1 : 0;
                this.formMail.content = response.data.content ? response.data.content : response.data.event.notification_body;
            })
                .catch(err => console.log(err));
        },
        saveNotification() {
            this.formMail.program_id = this.formMail.program.id;
            this.formMail.event_id = this.formMail.event.id;
            this.formMail.active = this.formMail.active ? 1 : 0;
            axios.post('/notifications', this.formMail).then(response => {
                this.dialog = false
                this.testNotification = null
            })
                .catch(function (err) {
                    if (err.response.status === 422) {
                        formMail.errors = err.response.data.errors
                    }
                });
            this.getDataNotificationSettingForForm(this.formMail.program);
        },
        addTag(tag) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(tag)
                return;
            }
            let item = document.getElementById('content');
            let c = document.createElement("textarea");
            c.value = tag;
            c.style.maxWidth = '100px';
            c.style.maxHeight = '100px';
            item.appendChild(c);
            c.focus();
            c.select();
            document.execCommand("copy");
            item.removeChild(c);
        },
        dataListEvents(event) {
            if (event.closeDialog) {
                this.dataForm = false
            }
            if (event.reload) {
                this.getStaffs()
            }
        },
        openMenuToogle(index) {
            for (var i in this.openMenu) {
                if (i !== index) {
                    this.$set(this.openMenu, i, false);
                }
            }

            if (!this.openMenu[index]) {
                this.$set(this.openMenu, index, true);
            } else {
                this.$set(this.openMenu, index, false);
            }
            // this.openMenu[index] = !this.openMenu[index];
        },
        getNotifications() {
            this.loading = true
            axios.get('/notifications', {
                params: {
                    programID: this.programID
                }
            })
                .then(res => {
                    this.rows = res.data
                    this.loading = false
                    this.formMail.program_id = this.programID
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false)
        },
        pickFile(column) {
            this.activeFilePickerColumn = column
            document.getElementById(column).click();
        },
        getDataNotificationSettingForForm(program) {
            this.programID = program.id;
            this.getUIDFromProgram();
            this.getNotifications();
        },
        onFilePicked(e) {
            const files = e.target.files
            if (files[0] !== undefined) {
                this.formModel[this.activeFilePickerColumn + '_media_name'] = files[0].name
                if (this.formModel[this.activeFilePickerColumn + '_media_name'].lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    this.formModel[this.activeFilePickerColumn + '_media_url'] = fr.result
                    this.formModel[this.activeFilePickerColumn + '_media_file'] = files[0] // this is an image file that can be sent to server...
                    this.formModel[this.activeFilePickerColumn + '_media_changed'] = true
                })
            } else {
                this.formModel[this.activeFilePickerColumn + '_media_name'] = ''
                this.formModel[this.activeFilePickerColumn + '_media_file'] = ''
                this.formModel[this.activeFilePickerColumn + '_media_url'] = ''
                this.formModel[this.activeFilePickerColumn + '_media_changed'] = true
            }
        },
        submitForm(scope) {
            this.form.has_error = false
            this.form.loading = true

            if (this.tabCount > 1) {
                for (let i = 2; i <= this.tabCount; i++) {

                }
            }

            this.$validator.validateAll(scope).then((valid) => {
                if (valid) {
                    this.saveForm()
                } else {
                    // Get first error and select tab where error occurs
                    let field = this.errors.items[0].field
                    let el = (typeof this.$refs[field] !== 'undefined') ? this.$refs[field] : null
                    let subtab = (el !== null) ? el[0].$parent.$vnode.key : null
                    let tab = (el !== null) ? el[0].$parent.$parent.$parent.$vnode.key : null

                    if (tab !== null) this.selectedTab = tab
                    if (tab !== null && subtab !== null) this.selectedSubTab[tab] = subtab

                    this.form.loading = false

                    return false
                }
            });
        },
        saveForm() {
            this.loading = true
            let that = this
            const model = this.model.split('\\')[2] || false;
            let settings = { headers: { 'content-type': 'multipart/form-data' } }
            // Remove image urls
            let formModel = Object.assign({}, this.formModel);

            if (this.programID) {
                // formModel = Object.assign({'program_id': this.programID}, this.formModel);
                formModel['program_id'] = this.programID;
            }

            // Adding other fields which are not in the columns
            this.otherFormModel = document.querySelectorAll('[id^=otherFormModel-]');
            _.map(this.otherFormModel, itemItr => {
                if (itemItr.value === 'skip') return;
                const key = itemItr.id.split('-')[1];
                if (key != 'main_currency') {
                    formModel[key] = (itemItr.value == 'uuid' && key == 'customer_id') ? that.customer_id : itemItr.value;
                }
            });

            for (let field in this.formModel) {
                if (_.endsWith(field, '_media_url') || _.endsWith(field, '_media_name') || _.endsWith(field, '_media_file') || field == 'avatar') {
                    formModel[field] = null;
                }
            }

            let formData = new FormData(document.getElementById('formModel'));
            formData.append('locale', this.$i18n.locale);
            formData.append('model', this.model);
            formData.append('formModel', JSON.stringify(formModel));
            formData.append('uuid', this.uuid);
            formData.append('program_id', this.programID);

            axios.post(this.api + '/save', formData, settings)
                .then(res => {
                    if (res.data.status === 'success') {
                        let action = (this.uuid === null) ? 'item_created' : 'item_saved';
                        this.getUIDFromProgram();
                        this.$root.$snackbar(this.$t(action));
                        if (model === 'Program') {
                            // this.$emit('data-list-events', {'closeDialog': true, 'reload': false});
                            this.$router.push({ name: 'user.program' });
                            return;
                        }
                        this.$emit('data-list-events', { 'closeDialog': true, 'reload': true })
                    }
                })
                .catch(err => {
                    if (typeof err.response !== 'undefined') {
                        if (typeof err.response.status !== 'undefined' && err.response.data.msg !== 'undefined') {
                            if (err.response.status == 422) {
                                this.$root.$snackbar(err.response.data.msg)
                                return
                            }
                        }
                        this.formModel.has_error = true
                        this.formModel.error = err.response.data.error
                        this.formModel.errors = err.response.data.errors || {}

                        // Get first error and select tab where error occurs
                        let field = Object.keys(this.formModel.errors)[0]
                        let el = (typeof this.$refs[field] !== 'undefined') ? this.$refs[field] : null
                        let tab = (el !== null) ? el[0].$parent.$vnode.key : null
                        if (tab !== null) this.selectedTab = tab

                        for (let field in this.formModel.errors) {
                            this.$validator.errors.add({
                                field: 'formModel.' + field,
                                msg: this.formModel.errors[field][0]
                            })
                        }
                    }
                })
                .finally(() => {
                    that.loading = false
                    that.form.loading = false

                })
        },
        getDataFromApi(data = null) {
            this.loading = true
            let that = this;
            this.uuid = data ? (data.notificationSetting && data.notificationSetting.length > 0 ? (data.notificationSetting[0].uuid ? data.notificationSetting[0].uuid : null) : null) : null;
            return new Promise((resolve, reject) => {
                axios.get(this.api, {
                    params: {
                        locale: this.$i18n.locale,
                        model: this.model,
                        uuid: this.uuid
                    }
                })
                    .then(res => {
                        if (res.data.status === 'success') {
                            let form = {}
                            form.items = res.data.form
                            form.loading = false
                            form.error = ''
                            form.errors = {}
                            form.has_error = false
                            form.success = false
                            that.loading = false
                            that.loadingForm = false
                            that.formModel = res.data.values;
                            resolve({
                                form
                            })
                        }
                    })
                    .catch(err =>
                        console.log(err.response)
                    )
                    .finally(() => that.loading = false)
            })
        },
        getUIDFromProgram() {
            this.loading = true
            let that = this;
            return new Promise((resolve, reject) => {
                return axios.get(this.notificationUidFromApi, {
                    params: {
                        programID: that.programID
                    }
                })
                    .then(res => {
                        this.getDataFromApi(res.data).then(data => {
                            that.form = data.form;
                            that.tabCount = Object.keys(that.form.items).length
                        });
                    })
                    .catch(err =>
                        console.log(err.response)
                    )
                    .finally(() => that.loading = false)
            })
        },
        getProgramsByUser() {
            this.loading = true
            let that = this;
            return new Promise((resolve, reject) => {
                axios.get(that.programApi)
                    .then(res => {
                        that.programs = res.data.programs;
                        const default_program = that.programs[0];
                        this.programID = default_program.id
                        this.getNotifications();
                        that.getDataNotificationSettingForForm(default_program);
                    })
                    .catch(err =>
                        console.log(err.response)
                    )
                    .finally(() => that.loading = false)
            })
        }
    }
}
</script>

<style>
.ck-editor__editable_inline {
    min-height: 300px;
}
</style>
